import React from 'react'
import { Footer } from 'antd/lib/layout/layout'
import styled from 'styled-components'
import { Col, Row } from 'antd'

import Layer3 from 'src/assets/images/scense 1/Layer3.png'
import Senpark from 'src/assets/images/scense 1/Senpark.png'
import Binance_Logo from 'src/assets/images/scense 4/bnb-chain-h.png'
import pancakeswap from 'src/assets/images/scense 4/pancakeswap.png'
import unity from 'src/assets/images/scense 4/unity.png'
import GoogleCloudLogo from 'src/assets/images/scense 4/Google-Cloud-Logo.png'
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint'
import {Link, Route} from "react-router-dom";

// import discordIcon from 'src/assets/images/social/discord.webp'
// import facebookIcon from 'src/assets/images/social/facebook.webp'
// import teleIcon from 'src/assets/images/social/tele.webp'
// import twitterIcon from 'src/assets/images/social/twitter.webp'
// import linkedIcon from 'src/assets/images/social/linked.jpg'

const Title = styled.h3`
  color: white;
  font-weight: 700;
  margin-bottom: 30px;
  @media screen and (max-width: 500px) {
    margin-bottom: 0;
  }
`

const ImgFooter2 = styled.img`
  margin-bottom: 10px;
  width: 50px;
`

const ImgFooter = styled.img`
  width: 200px;
  margin-bottom: 10px;
  object-fit: cover;
  @media screen and (max-width: 1024px) {
    width: 150px;
  }
  @media screen and (max-width: 600px) {
    width: 100px;
  }
`

// const ImgSocial = styled.img`
//   width: 30px;
//   height: 30px;
// `

const RowSenPark = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  @media screen and (max-width: 500px) {
    .text-center {
      text-align: center !important;
    }

    .ant-row-end {
      justify-content: center !important;
      padding: 20px;
    }
  }

`

const Detail = styled.a`
  color: white;
  margin-bottom: 10px;
  display: block;
`


const FooterSection = () => {
  const {lg} = useBreakpoint()

  return (
    <Footer style={{backgroundColor: '#ab3120', padding: '0px 0', overflow: 'hidden'}}>
      <div className="container">
        {/* <RowSenPark> */}
          {/*<Col xs={24} sm={12} lg={6} className="text-center">*/}
          {/*  <ImgFooter2 src={Senpark} alt=""/>*/}
          {/*  <ImgFooter src={Layer3} alt=""/>*/}
          {/*</Col>*/}
          {/*<Col xs={24} sm={12} lg={5} className="text-center">*/}
          {/*  <Title>Products</Title>*/}
          {/*  <Detail href="https://bombcrypto.io/" target="_blank">Bombcrypto</Detail>*/}
          {/*  /!*<Detail>Next Game</Detail>*!/*/}
          {/*  <Detail href="#">Stickcrypto</Detail>*/}
          {/*  /!*<Detail>Project Meta</Detail>*!/*/}
          {/*</Col>*/}
          {/*<Col xs={24} sm={12} lg={5} className="text-center">*/}
          {/*  <Title>About</Title>*/}
          {/*  <Detail href="https://t.me/senspark_group" target="_blank" rel="noreferrer">Community</Detail>*/}
          {/*  <Detail href="https://senspark.com/" target="_blank" rel="noreferrer">Metaverse</Detail>*/}

          {/*  <Detail href="https://senspark.com/contact" target="_blank">*/}
          {/*    Contact*/}
          {/*  </Detail>*/}
          {/*</Col>*/}
        {/* </RowSenPark> */}
        <Foot>
          <FootInfo><Link to="/terms-of-use">Terms of Use</Link></FootInfo>
          <FootInfo
            style={{borderLeft: '1px solid'}}
          >
            <Link to={'/privacy-policy'}>Privacy Policy</Link>
          </FootInfo>
          {/*<FootInfo><Link to='/contact'>Contact</Link></FootInfo>*/}
          <ContentFooter>
            Copyright © 2025 Senspark. All rights reserved.
          </ContentFooter>
        </Foot>
      </div>
    </Footer>
  )
}

const Foot = styled.div`
  text-align: center;
  padding-top: 25px;
  padding-bottom: 30px;
  color: white;
  @media (max-width: 599px) {
    font-size: 12px;
  }
`

const FootInfo = styled.span`
  padding: 0 20px;
  margin-bottom: 20px;
  font-size: 18px;
  @media (max-width: 599px) {
    font-size: 12px;
  }

  a {
    color: white;
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`
const LogoPartner = styled.img`
  width: 150px;
  padding: 10px 0;
  @media (max-width: 768px) {
    width: 120px;
  }
`

const ContentFooter = styled.p`
  margin-top: 20px;
  font-size: 18px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export default FooterSection
